function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "current",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M600 557 c-8 -8 -61 -34 -117 -58 -57 -24 -103 -47 -103 -52 0 -4 -4 -5 -10 -2 -5 3 -10 1 -10 -5 0 -6 -4 -8 -10 -5 -15 9 -12 -11 3 -23 10 -9 41 2 126 43 122 60 127 61 134 43 8 -20 28 13 25 41 -4 29 -18 36 -38 18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M296 408 c5 -8 1 -9 -12 -4 -10 4 -15 3 -10 -1 4 -4 -32 -27 -81 -50 l-88 -42 50 6 c28 3 58 10 68 15 10 5 26 11 36 13 9 2 34 15 55 29 29 20 34 27 22 31 -9 3 -23 7 -32 10 -9 3 -12 1 -8 -7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240 330 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78 303 c-73 -4 -78 -5 -78 -26 0 -41 14 -50 69 -45 34 3 57 1 69 -8 23 -18 151 -19 158 -1 2 7 -2 30 -11 50 -17 42 2 39 -207 30z m142 -23 c0 -20 -15 -25 -44 -14 -28 11 -18 34 14 34 23 0 30 -4 30 -20z m57 -18 c11 -28 11 -33 -2 -38 -23 -9 -45 15 -45 48 0 40 29 34 47 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605 291 c-3 -6 -1 -20 5 -31 6 -11 8 -25 5 -30 -3 -6 -1 -10 4 -10 6 0 12 11 13 25 0 14 1 30 2 37 1 15 -20 22 -29 9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 192 c-4 -3 -6 -20 -6 -38 0 -23 5 -33 20 -37 12 -3 20 0 20 7 0 19 34 46 57 46 20 0 53 -28 53 -46 0 -5 36 -9 80 -9 51 0 80 4 80 11 0 18 35 44 58 44 14 0 30 -12 43 -33 l20 -32 -7 40 c-4 22 -8 43 -10 46 -4 8 -401 9 -408 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66 144 c-9 -8 -16 -22 -16 -29 0 -18 27 -45 45 -45 18 0 45 27 45 45 0 18 -27 45 -45 45 -7 0 -21 -7 -29 -16z m52 -27 c4 -20 -25 -34 -40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338 149 c-34 -19 -16 -79 23 -79 21 0 49 26 49 45 0 17 -27 45 -43 45 -7 0 -20 -5 -29 -11z m50 -32 c4 -20 -25 -34 -40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z"
}));

var SvgVehicle14 = function SvgVehicle14(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle14, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle14.6ae1635b.svg";
export { ForwardRef as ReactComponent };